import i18n from 'i18next';
import capitalize from 'lodash/capitalize';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import TRANSLATIONS_EN from '@app/translations/en/translations.json';
import TRANSLATIONS_JA from '@app/translations/ja/translations.json';
import TRANSLATIONS_KO from '@app/translations/ko/translations.json';
import TRANSLATIONS_VI from '@app/translations/vi/translations.json';
import TRANSLATIONS_ZH_CN from '@app/translations/zh_CN/translations.json';

i18n.use(initReactI18next).init({
  supportedLngs: ['en', 'ja', 'ko', 'vi', 'zh-CN'],
  fallbackLng: 'en',
  resources: {
    ko: {
      translation: TRANSLATIONS_KO,
    },
    en: {
      translation: TRANSLATIONS_EN,
    },
    'zh-CN': {
      translation: TRANSLATIONS_ZH_CN,
    },
    ja: {
      translation: TRANSLATIONS_JA,
    },
    vi: {
      translation: TRANSLATIONS_VI,
    },
  },
  interpolation: {
    escapeValue: false,
    format(value, format) {
      if (format === 'capitalize') return capitalize(value);
      return value;
    },
  },
});

i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
});

const supportedLanguages = ['en', 'ja', 'ko', 'vi', 'zh-CN'] as const;
type SupportedLanguage = (typeof supportedLanguages)[number];

function normalizeLanguage(value: string): string {
  return value.toLowerCase().split('-')[0];
}

function toSupportedLanguage(value: string): SupportedLanguage | undefined {
  return supportedLanguages.find(
    (v) =>
      v === value ||
      v === normalizeLanguage(value) ||
      normalizeLanguage(v) === normalizeLanguage(value)
  );
}

export function detectLanguage(languages: string[]): SupportedLanguage {
  return languages.map(toSupportedLanguage).find((v) => v) || 'en';
}

// 서명 페이지에만 다국어 지원을 적용합니다.
const i18nSupportedPage = [
  '/participant',
  '/link',
  '/signing',
  '/document-bundle',
  '/embedded-participant',
];
if (i18nSupportedPage.some((path) => window.location.pathname.startsWith(path))) {
  i18n.changeLanguage(
    detectLanguage([...window.navigator.languages] || [window.navigator.language])
  );
} else {
  i18n.changeLanguage('ko');
}
